import React from "react";
import { createRoot } from "react-dom/client";
import OperatorAirportData from "./OperatorAirportData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderOperatorAirportData: unknown;
	}
}

export function renderOperatorAirportData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<OperatorAirportData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderOperatorAirportData = renderOperatorAirportData;
